module.exports = __webpack_public_path__ + "img/201912-1.ee8c1508.jpg";